import React from 'react';

interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

const Skeleton: React.FC<SkeletonProps> = ({
  width = '100%',
  height = '100%',
  className = '',
}) => {
  return (
    <div
      className={`bg-gray-300 animate-pulse rounded-md ${className}`}
      style={{ width, height }}
    />
  );
};

export default Skeleton;
